<template>
  <div class="body">
    <div class="merchant" v-if="fid <3 && $merchant.name">车商：{{ $merchant.name }}</div>
    <div class="loading" v-if="loading"><van-loading style="position: absolute;left:50%;right:50%;top: 50%;" type="spinner" /></div>
    <div v-if="!loading && auth">
      <van-tabs v-model="activeTab">
        <van-tab title="申报中" name="1" v-if="fid < 3">
          <ListComponent :refresh="refresh" :status="1" :active="activeTab" :ffid="fid" :car-modify="true" @refreshed="refresh = false"/>
        </van-tab>
        <van-tab title="待审核" name="2">
          <ListComponent :refresh="refresh" :status="2" :active="activeTab" :ffid="fid" :car-modify="false"  @refreshed="refresh = false"/>
        </van-tab>
        <van-tab title="被打回" name="3" v-if="fid < 3">
          <ListComponent  :status="3" :active="activeTab" :ffid="fid" :car-modify="true"/>
        </van-tab>
        <van-tab title="已通过" name="4">
          <ListComponent  :status="4" :active="activeTab" :ffid="fid" :car-modify="false"/>
        </van-tab>
        <van-tab title="已作废" name="-1">
          <ListComponent  :status="-1" :active="activeTab" :ffid="fid" :car-modify="false"/>
        </van-tab>
      </van-tabs>
      <div class="newForm">
        <van-button class="btn" round icon="plus" type="primary" @click="newForm"/>
    </div>
    </div>
    
    <div v-else-if="!loading">
      <img v-if="fid == 1" style="width: 100%;" src="//img.shaoxing.com.cn/a/10001/202402/1051c650e4821671e678b04f93d2a5e6.jpeg" alt="">
      <img v-else-if="fid == 2" style="width: 100%;" src="//img.shaoxing.com.cn/a/10001/202404/f421c85539119cc9aef642360bb1ebd5.jpeg" alt="">
    </div>
  </div>
</template>
<script>
// import Vconsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new Vconsole()

import axios from 'axios'
import { util,mc } from '../../assets/common2.js'
import ListComponent from '@/components/ListComponent.vue'
// import { Loading } from 'vant'
export default {
  name: 'CarList',
  props: {
  },
  data () {
    return {
      fid: 1,
      activeTab: '1',
      refresh: false,
      auth: false,
      loading: true
    }
  },
  components: {
    ListComponent

  },
  computed: {
  },
  created: function () {
    if (!mc.isClient()) {
      this.$router.push('/car/index')
    } else {
      this.fid = this.$route.params.fid ? this.$route.params.fid : 1
      this.$store.commit('setFid',this.fid)
      // console.log(vConsole);
      if (this.fid == 3) {
        this.auth = true
        this.loading = false
      } else {
        this.authHandle()
      }
    }
    
  },
  mounted: function () {
    
  },
  methods: {
    newForm() {
      this.refresh = false
      if (this.fid == 3) {
        this.$router.push('/car/oldfornew/0')
      } else {
        this.$router.push('/car/form/0')
      }
      
    },
    authHandle() {
      util.Arequest((data) => {
        var formData = new FormData()
        formData.append('token',data.token)
        axios.post(`/encrypt3/form/auth?userid=${data.userid}&fid=${this.fid}`,formData).then(res => {
            if (res.data.msg == 'ok') {
              this.auth = true
              this.$merchant = res.data.merchant
              this.loading = false
            } else if (res.data.msg == 'not allow') {
              this.auth = false
              this.loading = false
              // this.$toast('无权限')
            } else {
              this.$toast('网络繁忙\n稍后再进')
            }
          }).catch(() => {
            this.$toast('网络繁忙\n稍后再进')
          })
      })
    }
  },
  watch: {
    $route(to,from) {
      if (to.path == '/car' && from.name == 'CarForm' && this.$store.state.needRefresh) {
        // if (from.params.form_id>0) {
        //   this.activeTab = '2'
        // }
        this.$store.commit('setNeedRefresh',false)
        this.refresh = true
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .main {
  margin-top: 56.3vw;
} */

</style>
<style>
html,body {
  height: 100%
}
.body {
  background-color: aliceblue;
}
.merchant {
  display: block;
  position: sticky;
  top: 0;
  height: 16px;
  font-size: 14px;
  line-height: 16px;
  padding-left: 1rem;
  text-align: left;
  background-color: #fff;
  z-index: 999;
}
.loading {
  width: 100%;
  height: 100vh;
}
.newForm {
  position:fixed;
  bottom: 3rem;
  right: 2rem;
}
.newForm .btn {
  width: 3.5rem;
  height: 3.5rem;
}
.body .van-tabs__wrap {
  position: sticky;
  top: 16px;
  z-index: 999;
}
.body .van-search {
  position: sticky;
  top: 60px;
  z-index: 999;
}
</style>
